// Klaviyo Newsletter Form Handler
// Submits to Klaviyo's client-side Subscribe API:
// https://developers.klaviyo.com/en/reference/create_client_subscription
(function() {
  'use strict';

  var KLAVIYO_REVISION = '2026-07-15';

  function initKlaviyoForms() {
    const forms = document.querySelectorAll('.klaviyo-newsletter-form');

    forms.forEach(function(form) {
      // Remove any existing listeners to prevent duplicates
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);

      newForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const emailInput = newForm.querySelector('input[name="EMAIL"]');
        const responseDiv = newForm.querySelector('.newsletter-response');
        const submitButton = newForm.querySelector('button[type="submit"]');

        const companyId = newForm.getAttribute('data-klaviyo-company-id');
        const listId = newForm.getAttribute('data-klaviyo-list-id');
        const signupSource = newForm.getAttribute('data-signup-source');

        if (!companyId || !listId) {
          showMessage(responseDiv, 'Newsletter is not configured. Please add your Klaviyo Public API Key and List ID in Theme Settings → Klaviyo.', 'error');
          return false;
        }

        const email = emailInput.value;

        // Loading state
        submitButton.disabled = true;
        const originalButtonHTML = submitButton.innerHTML;
        submitButton.innerHTML = '<span>Subscribing...</span>';

        const endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId);

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: { marketing: { consent: 'SUBSCRIBED' } }
                    },
                    properties: signupSource ? { signup_source: signupSource } : undefined
                  }
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId }
              }
            }
          }
        };

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify(payload)
        })
          .then(function(res) {
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonHTML;

            // Client Subscribe API returns 202 (Accepted) with an empty body on success
            if (res.status === 202) {
              showMessage(responseDiv, 'Thank you for subscribing!', 'success');
              newForm.reset();
              return;
            }

            // Attempt to surface Klaviyo's error detail
            return res.json().then(function(data) {
              var errorMsg = 'An error occurred. Please try again.';
              if (data && data.errors && data.errors.length && data.errors[0].detail) {
                errorMsg = data.errors[0].detail;
              }
              showMessage(responseDiv, errorMsg, 'error');
            }).catch(function() {
              showMessage(responseDiv, 'An error occurred. Please try again.', 'error');
            });
          })
          .catch(function() {
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonHTML;
            showMessage(responseDiv, 'Failed to connect. Please try again.', 'error');
          });

        return false;
      }, true);
    });
  }

  function showMessage(element, message, type) {
    if (!element) return;
    element.textContent = message;
    element.style.display = 'block';
    element.className = 'newsletter-response mt-2 mb-0 ' + (type === 'success' ? 'text-success' : 'text-danger');

    // Auto-hide success messages after 5 seconds
    if (type === 'success') {
      setTimeout(function() {
        element.style.display = 'none';
      }, 5000);
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoForms);
  } else {
    initKlaviyoForms();
  }

  // Also initialize on Shopify section load events
  document.addEventListener('shopify:section:load', initKlaviyoForms);
})();
